import React, { useState } from "react";
import { authenticatedPost } from "../utils/apiUtils";
import Swal from "sweetalert2";
import ImageCarousel from "./ImageCarousel";

const Asset = ({ asset }) => {
  const [newProperty, setNewProperty] = useState({ name: "", value: "" });

  const addProperty = async () => {
    const hasEmptyProperty = !newProperty.name || !newProperty.value;

    if (hasEmptyProperty) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Detail must have a name and value.",
      });
      return;
    }

    try {
      console.log(`📡 Adding property to asset ${asset.id}...`);
      const response = await authenticatedPost(
        `/assets/${asset.id}/properties`,
        newProperty
      );

      if (response.ok) {
        const data = await response.json();
        asset.properties.push(data);
        setNewProperty({ name: "", value: "" });
        console.log("✅ Property added successfully");
      } else {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
    } catch (error) {
      console.error("❌ Error adding property:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "There was a problem adding the detail. Please try again.",
      });
    }
  };

  // Find a property named 'images' (case-insensitive)
  const imagesProperty = asset.properties.find(
    (p) => p.name && p.name.toLowerCase() === "images" && p.value
  );
  // Split value by comma or whitespace, filter out empty strings
  const imageUrls = imagesProperty
    ? imagesProperty.value
        .split(/[\s,]+/)
        .map((s) => s.trim())
        .filter(Boolean)
    : [];

  return (
    <div className="asset-properties-container">
      {/* Image Carousel if images exist */}
      {imageUrls.length > 0 && <ImageCarousel images={imageUrls} />}

      {/* Existing Properties Display */}
      <div className="properties-list mb-4">
        {asset.properties.map((property) => (
          <div
            key={property.id}
            className="property-item mb-2 p-2 bg-light rounded"
          >
            <strong>{property.name}: </strong>
            <span>{property.value}</span>
          </div>
        ))}
      </div>

      {/* Add New Property Form */}
      <div className="add-property-form border p-2 mt-2 bg-light rounded">
        <div className="mb-2">
          <input
            type="text"
            className="form-control form-control-sm mb-2"
            placeholder="Detail Name"
            value={newProperty.name}
            onChange={(e) =>
              setNewProperty({ ...newProperty, name: e.target.value })
            }
          />
          <input
            type="text"
            className="form-control form-control-sm mb-2"
            placeholder="Detail Value"
            value={newProperty.value}
            onChange={(e) =>
              setNewProperty({ ...newProperty, value: e.target.value })
            }
          />
          <button
            onClick={addProperty}
            className="btn btn-primary btn-sm w-100"
            disabled={!newProperty.name || !newProperty.value}
          >
            <i className="fas fa-plus me-1"></i>
            Add Detail
          </button>
        </div>
      </div>
    </div>
  );
};

export default Asset;
